// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageShow_wrapper__Wz+4b","main-img":"ImageShow_main-img__vDlUn","img-list":"ImageShow_img-list__1VXUT","other-img":"ImageShow_other-img__rRyfs"};